<template>
  <Modal :full-screen="true">
    <div
      :class="[
        'h-full min-h-screen w-full min-w-full overflow-y-auto px-6 pt-6 text-white md:pt-10',
        'flex flex-col items-center justify-center sm:px-12 sm:pb-12 fixed top-0 bg-black',
      ]"
    >
      <div class="flex self-end">
        <img
          class="h-6 sm:h-8"
          src="/assets/images/site/business-logo.svg"
          alt="Motion Array Business"
          title="Motion Array Business"
          draggable="false"
        >
      </div>
      <div
        v-if="showLoader"
        class="m-auto flex h-full items-center justify-center"
      >
        <Loader loader-icon-class="h-10 w-10 border-b-2 border-white" />
      </div>
      <div
        v-else
        class="m-auto max-w-[720px] text-center"
      >
        <h1 class="text-4xl md:text-5xl">
          {{ modalTitle }}
        </h1>
        <p class="my-4 text-sm text-b80 md:text-lg">
          {{ modalMessage }}
        </p>
        <div class="m-auto mt-8 flex items-center justify-center">
          <button
            :class="[
              'rounded bg-white px-4 py-2',
              'mr-3 text-xl font-bold text-black',
              { 'pointer-events-auto': showLoader },
            ]"
            :disabled="showLoader"
            @click="browseCatalog"
          >
            Browse Catalog
          </button>
          <div class="text-xs text-white">
            press <span class="font-medium">Enter ↵</span>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import axios from 'axios';
import Modal from '@/components/Modal.vue';
import Loader from '@/components/Loader.vue';
import Cookies from 'js-cookie';
import { COOKIES, USER_LEAD_TYPE, TYPE_FORM_TIMEOUT } from '@/constants';
import { addToSuperProperties } from '@/utils/eventSuperProperties';

export default {
  components: { Modal, Loader },
  props: {
    isPricingPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeout: null,
      showLoader: true,
    };
  },
  computed: {
    modalTitle() {
      return this.isPricingPage
        ? 'Thanks for your interest in the Business Plan'
        : 'Speak to you soon!';
    },
    modalMessage() {
      return this.isPricingPage
        ? 'We’ll be in touch soon. In the meantime, enjoy browsing the Motion Array catalog.'
        : 'Our team will reach out to you shortly. In the meantime, enjoy browsing the Motion Array catalog.';
    },
    isPlUser() {
      return this.$store.state.user?.leadInfoJourney?.includes(USER_LEAD_TYPE.PL);
    },
    isSqlUser() {
      return this.$store.state.user?.leadInfoJourney?.includes(USER_LEAD_TYPE.SQL);
    },
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.getLeadTypeInfo();
      this.showLoader = false;
    }, TYPE_FORM_TIMEOUT);
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  },
  methods: {
    browseCatalog() {
      this.$emit('typeFormSubmitted', false);
      setTimeout(() => {
        this.$store.dispatch('setOpenTopNavDrawer', false);
        this.$emit('close');
        this.showLoader = false;
      }, 100);
      this.$router.push('/');
    },
    async getLeadTypeInfo() {
      try {
        const { data } = await axios.get('/api/v3/enterprise/leadInfo');
        const leadInfoClassification = data?.leadInfo?.classification?.toUpperCase();
        const leadInfoJourney = data?.journey?.map(value => value.toUpperCase());
        this.isLeadInfoSuccess = true;

        if (leadInfoClassification) {
          this.leadInfoClassification = leadInfoClassification;
          this.$store.dispatch('setUserLeadType', leadInfoClassification);
          Cookies.set(COOKIES.NAMES.LEAD_INFO_CLASSIFICATION, leadInfoClassification, {
            expires: 7,
          });
          addToSuperProperties({ lead_type_indication: leadInfoClassification });
        }
        if (leadInfoJourney?.length > 0) {
          this.$store.dispatch('setUserLeadInfoJourney', leadInfoJourney);
          Cookies.set(COOKIES.NAMES.LEAD_INFO_JOURNEY, JSON.stringify(leadInfoJourney), {
            expires: 7,
          });
          addToSuperProperties({ journey: leadInfoJourney });
        }
      } catch (error) {
        console.error('fetching lead info error', { error });
        this.isLeadInfoSuccess = false;
      }
    },
  },
};
</script>

<style scoped>
>>> .modal-mask {
  min-width: 100vw;
  max-width: 100vw;
  background-color: rgb(0, 1, 29);
}
>>> .modal-container {
  width: 100%;
  height: 100%;
  background-color: rgb(0, 1, 29);
}
</style>
